module.exports = __webpack_public_path__ + "static/media/lojo_deusto.c692b4f9.jpg";